import { AbacusClient, AbacusClientOptions } from "@abacus/api-client";
import { AbacusStateActionStatus } from "@abacus/api-state-client";
import { Optional } from "@abacus/common";

// Configs

export type AbacusRoyaltiesClientOptions =
  | { client: AbacusClient }
  | (Optional<AbacusClientOptions, "domain"> & { client?: undefined });

// Requests

// Responses

export interface HelloResponse {
  status: string;
}

// Types

export interface StatementPeriodAdjustmentFile {
  error_type?: StatementPeriodAdjustmentFileErrorType;
  file_name: string;
  invalid_file_location?: string;
  invalid_row_count: number;
  md5sum?: string;
  statement_period_adjustment_file_id: number;
  statement_period_id: number;
  total_file_amount_multicurrency: string;
  total_rounded_amount_multicurrency: string;
  valid_file_location: string;
  valid_row_count: number;
}

export enum StatementPeriodAdjustmentFileActionName {
  UploadFile = "upload_file",
}

export enum StatementPeriodAdjustmentFileErrorType {
  ContentError = "content_error",
  FormatError = "format_error",
}

export interface StatementPeriodPaymentEntityState {
  abacus_state_id: number;
  action_name: string;
  action_status: AbacusStateActionStatus;
  reference_payment_entity_id: number;
  statement_period_id: number;
  statement_period_payment_entity_id: number;
}
